import { defaultMetaTags } from 'global/SEO/constants';
import { SITE_URL, AVATAR_URL } from 'constants/api';

import type { ProfileGraphInfo } from './types';

interface IMetaTags {
  title: string;
  url: string;
  image: string;
}

export const generateMetatags = (user: ProfileGraphInfo): IMetaTags => {
  if (!user?.profile) return defaultMetaTags;

  const { profile } = user;

  const title = `${profile?.fullname} (${profile?.username})`;
  const image = profile.avatar_urls.default_url ?? '';

  return {
    title,
    url: `${SITE_URL}/${profile?.username}`,
    image,
  };
};

export const extractUserData = (userData: ProfileGraphInfo) => {
  const { username, fullname, avatar_urls } = userData?.profile || {};
  const { idea_count, follower_count } = userData?.statistic || {};

  const avatarUrl = avatar_urls?.default_url.startsWith('http')
    ? avatar_urls?.default_url
    : `${AVATAR_URL}/${avatar_urls?.default_url || ''}`;

  return {
    username,
    fullname,
    avatarUrl,
    ideaCount: idea_count,
    followerCount: follower_count,
    userData,
  };
};

export const isUsername = (str: string) => {
  const regex = /^[a-zA-Z0-9]+$/i;
  if (regex.test(str)) {
    return str.toLowerCase();
  }
  return false;
};
